<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            v-model="alertCancel.show"
            @hidden="alertCancel.show = false"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12 text-center">
                            <h3 class="mb-0">{{(alertCancel.type == 'success' ? 'เรียบร้อยแล้ว' : 'มีบางรายการต้องรอดำเนินการจากทีมงาน')}}</h3>
                        </div>
                    </div>
                </div>
            </template>
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-lg-12 text-center" v-if="alertCancel.type == 'success'">
                        <span class="text-green">
                            <i class="far fa-check-circle fa-5x"></i>
                        </span>
                        <h3 class="py-2">ทำรายการเรียบร้อยแล้ว</h3>
                        <h4 class="pb-4">สามารถตรวจสอบสถานะการยกเลิกได้ <router-link tag="a" to="/historycancel"><u>ที่นี่</u></router-link></h4>
                    </div>
                    <div class="col-lg-12 text-center" v-else>
                        <span class="text-red">
                            <i class="fas fa-exclamation-circle fa-5x"></i>
                        </span>
                        <h3 class="py-2">รายการดังต่อไปนี้ ต้องรอดำเนิการจากทีมงาน</h3>
                        <h4 class="pb-4">หมายเลขติดตามพัสดุ: 
                            <span v-for="(tracking, index) in alertCancel.tracking" :key="index">{{(index>0?',':'') + tracking}}</span>
                        </h4>
                        <hr class="my-4" />
                        <h4>สามารถตรวจสอบสถานะการยกเลิกได้ <router-link tag="a" to="/historycancel"><u>ที่นี่</u></router-link></h4>
                    </div>
                    <div class="col-lg-12 text-center">
                        <b-button 
                            v-if="alertCancel.receiptId > 0"
                            size="lg" 
                            variant="success"
                            @click="confirm()" >
                            พิมพ์ใบเสร็จใหม่
                        </b-button>
                        <router-link tag="a" to="/historycancel"  v-else>
                            <b-button 
                                size="lg" 
                                variant="success" >
                                ตกลง
                            </b-button>
                        </router-link>
                    </div>
                </div>
            </card>
            
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ModalAlertCancel" ,
    props: {
        alertCancel: Object,
    },
    data(){
        return{
         
        }
    },
    methods:{
        confirm(){
            this.alertCancel.funcConfirm( this.alertCancel.receiptId )
            this.$router.push('/')
        }
    }
}
</script>
